import React, {
  useMemo,
  useCallback,
  useState,
  useContext,
  useRef
} from "react";
import {
  useSpacePostQuery,
  useSpacePost,
  useSpaceQuery
} from "../../Helpers/IOClient";
import { useSpace } from "../../Contexts/SpaceContext";
import SuspenseLoader from "../SuspenseLoader/SuspenseLoader";
import { v4 as uuid } from "uuid";
import { useToast } from "../Toast/ToastProvider";
import { handleError } from "../../Helpers/MiscHelper";
import { FormattedMessage } from "react-intl";
import { useCurrentAccount } from "../../Contexts/UserContext";

export const AgendaPreferenceContextr = React.createContext();
export const AgendaPreferenceRefetchContext = React.createContext();
export const AgendaViewsRefetcherContext = React.createContext();
export const AgendaViewsContext = React.createContext();
export const AgendaViewsChangeSelectedViewContext = React.createContext();
export const AgendaUpdateViewsContext = React.createContext();
export const AgendaCreateViewContext = React.createContext();
export const AgendaReorderdViewsContext = React.createContext();
export const AgendaDeleteViewContext = React.createContext();

export const AgendaCurrentViewContext = React.createContext();
export const AgendaCurrentViewChangesContext = React.createContext();
export const AgendaCurrentViewSubmitChangesContext = React.createContext();

export const useAgendaPreferences = () => {
  const context = React.useContext(AgendaPreferenceContextr);
  return context;
};
export const useAgendaPreferencesRefetch = () => {
  const context = React.useContext(AgendaPreferenceRefetchContext);
  return context;
};

const uid = uuid();

const AgendaPreferences = ({ children }) => {
  const space = useSpace();

  const [viewData, setViewData] = useState(null);

  const preferenceAgendaBody = useMemo(() => {
    return [
      {
        Key: `air-agenda-views-${space?.Id}`
      },
      {
        Key: `air-agenda-last-view-${space?.Id}`
      }
    ];
  }, [space?.Id]);

  const { data, loading, refetch } = useSpacePostQuery(
    `Preference/GetMutiple`,
    preferenceAgendaBody,
    {
      onSuccess: (d) => {
        if (!d || d.length === 0)
          setViewData([
            {
              ...PersonalSettingsDefault,
              id: uid
            }
          ]);
        try {
          const parsed = JSON.parse(d[0].Value);

          if (Array.isArray(parsed) && parsed.length > 0) setViewData(parsed);
          else {
            setViewData([
              {
                ...PersonalSettingsDefault,
                id: uid
              }
            ]);
          }
        } catch (error) {
          const uid2 = uuid();
          setViewData([
            {
              ...PersonalSettingsDefault,
              id: uid2
            }
          ]);
        }
      }
    }
  );

  const resolvedLastView = useMemo(() => {
    if (Array.isArray(viewData) && !loading) {
      if (data?.[1]?.Value) {
        const index = viewData.findIndex((e) => e.id === data?.[1]?.Value);
        if (index !== -1) return data?.[1]?.Value;
      }
    }
    return null;
  }, [data, loading, viewData]);

  if (loading || !viewData) return <SuspenseLoader />;
  //

  return (
    <AgendaViewsRefetcherContext.Provider value={refetch}>
      <AgendaViewHandler
        resolvedViews={viewData}
        setViews={setViewData}
        lastUsedV={resolvedLastView}
      >
        {children}
      </AgendaViewHandler>
    </AgendaViewsRefetcherContext.Provider>
  );
};

const PersonalSettingsDefault = {
  workschedule: [
    {
      enabled: false,
      day: 0,
      workBegin: "09:00",
      workEnd: "18:00",
      lunchBegin: "13:00",
      lunchEnd: "14:00"
    },
    {
      enabled: true,
      day: 1,
      workBegin: "09:00",
      workEnd: "18:00",
      lunchBegin: "13:00",
      lunchEnd: "14:00"
    },
    {
      enabled: true,
      day: 2,
      workBegin: "09:00",
      workEnd: "18:00",
      lunchBegin: "13:00",
      lunchEnd: "14:00"
    },
    {
      enabled: true,
      day: 3,
      workBegin: "09:00",
      workEnd: "18:00",
      lunchBegin: "13:00",
      lunchEnd: "14:00"
    },
    {
      enabled: true,
      day: 4,
      workBegin: "09:00",
      workEnd: "18:00",
      lunchBegin: "13:00",
      lunchEnd: "14:00"
    },
    {
      enabled: true,
      day: 5,
      workBegin: "09:00",
      workEnd: "18:00",
      lunchBegin: "13:00",
      lunchEnd: "14:00"
    },
    {
      enabled: false,
      day: 6,
      workBegin: "09:00",
      workEnd: "18:00",
      lunchBegin: "13:00",
      lunchEnd: "14:00"
    }
  ],
  all: false,
  agendaView: 1,
  selectedUser: null,
  calendarView: 2,
  name: "Vista Geral"
};

const AgendaViewHandler = ({
  resolvedViews,
  lastUsedV,
  setViews,
  children
}) => {
  // const refetchView = useContext(AgendaViewsRefetcherContext);

  const [lastUsedView, setLastUsedView] = useState(
    () => lastUsedV ?? resolvedViews[0].id
  );

  const createToast = useToast();
  // const intl = useIntl();
  const space = useSpace();

  const [postViewChanges] = useSpacePost("Preference/SetMultiple", null, {
    onSuccess: ({ data }) => {
      const parsed = JSON.parse(data[0].Value);
      setViews(parsed);
      createToast({
        pos: "tm",
        type: "success",
        description: <FormattedMessage id={"SAVE_SUCCESS"} />
      });
      if (data[1]?.Value) {
        setLastUsedView(data[1].Value);
      }
      // console.log(parsed);
      // if (typeof refetchView === "function") refetchView();
    },
    onError: ({ error }) => {
      handleError(createToast, error);
    }
  });

  const [postViewChangesNoRefetch] = useSpacePost(
    "Preference/SetMultiple",
    null,
    {}
  );

  const handleViewChange = useCallback(
    (viewId) => {
      postViewChangesNoRefetch([
        {
          Key: `air-agenda-last-view-${space?.Id}`,
          Value: viewId
        }
      ]);
      setLastUsedView(viewId);
    },
    [postViewChangesNoRefetch, space?.Id]
  );

  const handleViewChanges = useCallback(
    (view) => {
      const { id } = view;
      const existingIndex = resolvedViews.findIndex((e) => e.id === id);

      if (existingIndex !== -1) {
        const newViews = [...resolvedViews];
        newViews[existingIndex] = view;
        postViewChanges([
          {
            Key: `air-agenda-views-${space?.Id}`,
            Value: JSON.stringify(newViews)
          }
        ]);
      } else {
        postViewChanges([
          {
            Key: `air-agenda-views-${space?.Id}`,
            Value: JSON.stringify([...resolvedViews, view])
          }
        ]);
      }
    },
    [postViewChanges, resolvedViews, space?.Id]
  );

  const handleDeleteView = useCallback(
    (view) => {
      const { id } = view;
      const existingIndex = resolvedViews.findIndex((e) => e.id === id);

      if (existingIndex !== -1) {
        const newViews = [...resolvedViews];
        newViews.splice(existingIndex, 1);
        postViewChanges([
          {
            Key: `air-agenda-views-${space?.Id}`,
            Value: JSON.stringify(newViews)
          },
          {
            Key: `air-agenda-last-view-${space?.Id}`,
            Value: newViews[0].id
          }
        ]);
      }
    },
    [postViewChanges, resolvedViews, space?.Id]
  );

  const handleCreateView = useCallback(
    (view) => {
      postViewChanges([
        {
          Key: `air-agenda-views-${space?.Id}`,
          Value: JSON.stringify([...resolvedViews, view])
        },
        {
          Key: `air-agenda-last-view-${space?.Id}`,
          Value: view.id
        }
      ]);
    },
    [postViewChanges, resolvedViews, space?.Id]
  );

  const handleReorderViews = useCallback(
    (views) => {
      const currentViewIndex = views.findIndex((e) => e.id === lastUsedView);
      if (currentViewIndex !== -1) {
        postViewChanges([
          {
            Key: `air-agenda-views-${space?.Id}`,
            Value: JSON.stringify(views)
          }
        ]);
      } else {
        postViewChanges([
          {
            Key: `air-agenda-views-${space?.Id}`,
            Value: JSON.stringify(views)
          },
          {
            Key: `air-agenda-last-view-${space?.Id}`,
            Value: views[0].id
          }
        ]);
      }
    },
    [lastUsedView, postViewChanges, space?.Id]
  );

  return (
    <AgendaViewsContext.Provider value={resolvedViews}>
      <AgendaDeleteViewContext.Provider value={handleDeleteView}>
        <AgendaUpdateViewsContext.Provider value={handleViewChanges}>
          <AgendaReorderdViewsContext.Provider value={handleReorderViews}>
            <AgendaCreateViewContext.Provider value={handleCreateView}>
              <AgendaViewsChangeSelectedViewContext.Provider
                value={handleViewChange}
              >
                <AgendaCurrentViewPreferencesTemp
                  lastUsedView={lastUsedView}
                  resolvedViews={resolvedViews}
                >
                  {children}
                </AgendaCurrentViewPreferencesTemp>
              </AgendaViewsChangeSelectedViewContext.Provider>
            </AgendaCreateViewContext.Provider>
          </AgendaReorderdViewsContext.Provider>
        </AgendaUpdateViewsContext.Provider>
      </AgendaDeleteViewContext.Provider>
    </AgendaViewsContext.Provider>
  );
};

const AgendaCurrentViewPreferencesTemp = ({
  lastUsedView,
  resolvedViews,
  children
}) => {
  const updateView = useContext(AgendaUpdateViewsContext);

  const getInitial = React.useCallback(() => {
    if (!resolvedViews || resolvedViews.length === 0) return null;
    const source = lastUsedView
      ? resolvedViews.find((v) => v.id === lastUsedView)
      : resolvedViews[0];
    return source
      ? JSON.parse(JSON.stringify(source))
      : JSON.parse(JSON.stringify(resolvedViews[0]));
  }, [lastUsedView, resolvedViews]);

  const [tempView, setTempViewInternal] = useState(getInitial);

  // Reset temp when the original (resolvedViews or lastUsedView) changes
  React.useEffect(() => {
    setTempViewInternal(getInitial());
  }, [getInitial]);

  const currentUser = useCurrentAccount();

  const selectedUserId = useMemo(() => {
    if (tempView && tempView.selectedUser) {
      return tempView.selectedUser;
    } else return "";
  }, [tempView]);

  // Exposed setter that accepts either a partial object or an updater function.
  const setTempView = useCallback((updater) => {
    setTempViewInternal((prev) => {
      let next;
      if (typeof updater === "function") {
        next = updater(prev);
      } else if (updater && typeof updater === "object") {
        next = { ...(prev || {}), ...updater };
      } else {
        next = updater;
      }
      return next ? JSON.parse(JSON.stringify(next)) : next;
    });
  }, []);

  const NonCurrentWorkshecudleChanges = useRef(false);

  const getTempWorkScheduleFromDifUserUrl = useMemo(() => {
    if (selectedUserId && selectedUserId !== currentUser.Id) {
      return `calendars/GetMultiple/${selectedUserId}`;
    } else {
      if (NonCurrentWorkshecudleChanges.current) {
        const oldV = getInitial();
        if (oldV.workschedule) {
          setTempView({
            workschedule: oldV.workschedule
          });
          NonCurrentWorkshecudleChanges.current = false;
        }
      }
      return null;
    }
  }, [currentUser.Id, getInitial, selectedUserId, setTempView]);

  useSpaceQuery(getTempWorkScheduleFromDifUserUrl, null, {
    cache: false,
    onSuccess: ({ data }) => {
      try {
        const resolvedData = JSON.parse(data);
        if (Array.isArray(resolvedData)) {
          const firstWS = resolvedData[0]?.workschedule;
          if (firstWS) {
            setTempView({
              workschedule: firstWS
            });
            NonCurrentWorkshecudleChanges.current = true;
          }
        }
      } catch (error) {
        // if (NonCurrentWorkshecudleChanges.current) {
        const oldV = getInitial();
        if (oldV.workschedule) {
          setTempView({
            workschedule: oldV.workschedule
          });
        }
        // }
        //No Preference saved
      }
    }
  });

  const handleSubmitChanges = useCallback(() => {
    updateView(tempView);
  }, [tempView, updateView]);

  return (
    <AgendaCurrentViewContext.Provider value={lastUsedView}>
      <AgendaPreferenceContextr.Provider value={tempView}>
        <AgendaCurrentViewChangesContext.Provider value={setTempView}>
          <AgendaCurrentViewSubmitChangesContext.Provider
            value={handleSubmitChanges}
          >
            {children}
          </AgendaCurrentViewSubmitChangesContext.Provider>
        </AgendaCurrentViewChangesContext.Provider>
      </AgendaPreferenceContextr.Provider>
    </AgendaCurrentViewContext.Provider>
  );
};

export default AgendaPreferences;
